module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//modal-close.png?v=264bc739";